import { employeeProfileEdit, personalInfoTranslate } from '../../../../i18n/translatedMessages';

export const Personal = ({ onChange, data, error }) => {
  return (
    <div className="content-form">
      <div className="row">
        <div className="col">
          <h3>{personalInfoTranslate.personalInformation}</h3>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <label htmlFor="name">Name</label>
          <input type="text" name="name" id="name" onChange={onChange} value={data?.name || ''} className={error.name ? 'error' : ''} />
          {error.name && <small>{employeeProfileEdit.profileError}</small>}
        </div>
      </div>
      <div className="row">
        <div className="col">
          <label htmlFor="mail">Email Personal</label>
          <input type="email" name="mail" id="mail" onChange={onChange} value={data?.mail || ''} className={error.mail ? 'error' : ''} disabled />
          {error.mail && <small>{employeeProfileEdit.profileError}</small>}
        </div>
      </div>
      <div className="row">
        <div className="col">
          <label htmlFor="phone">Telefono</label>
          <input type="tel" maxLength={15} name="phone" id="phone" onChange={onChange} value={data?.phone || ''} className={error.phone ? 'error' : ''} />
          {error.phone && <small>{employeeProfileEdit.profileError}</small>}
        </div>
      </div>
      <div className="row">
        <div className="col">
          <label htmlFor="national_identification_number">Documento</label>
          <input type="number" name="national_identification_number" id="national_identification_number" onChange={onChange} value={data?.national_identification_number || ''} className={error.national_identification_number ? 'error' : ''} />
          {error.national_identification_number && <small>{employeeProfileEdit.profileError}</small>}
        </div>
      </div>
      <div className="row">
        <div className="col">
          <label htmlFor="birth">Fecha de Nacimiento</label>
          <input type="date" name="birth" id="birth" onChange={onChange} value={data.birth || ''} className={error.birth ? 'error' : ''} />
          {error.birth && <small>{employeeProfileEdit.profileError}</small>}
        </div>
      </div>
    </div>
  );
};
